export default __webpack_public_path__ + "ed4610743e4dbeda64c3bf4f5b6197c0.jpg";